import { render, staticRenderFns } from "./EditMoonpayCurrency.vue?vue&type=template&id=0844d8b0&"
import script from "./EditMoonpayCurrency.vue?vue&type=script&lang=js&"
export * from "./EditMoonpayCurrency.vue?vue&type=script&lang=js&"
import style0 from "./EditMoonpayCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports